export const types = { CA: "savings", CC: "checking", CBB: "CBB" };
export const ARS = "ARS";
export const CHECKING_ACCOUNT = "CC";
